import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { AnyFunction } from '@mews/std';
import { getRepositoryQueryKey } from './getRepositoryQueryKey';

export const useInvalidateRepositoryQuery = <RepositoryRegistry>() => {
    const queryClient = useQueryClient();

    const callBackFn = async <
        RepositoryName extends keyof RepositoryRegistry,
        MethodName extends keyof RepositoryRegistry[RepositoryName],
        Method extends RepositoryRegistry[RepositoryName][MethodName] extends AnyFunction
            ? RepositoryRegistry[RepositoryName][MethodName]
            : never,
    >(
        repositoryName: RepositoryName,
        methodName?: MethodName,
        params?: Partial<Parameters<Method>[0]>
    ) =>
        queryClient.invalidateQueries({
            queryKey: getRepositoryQueryKey<RepositoryRegistry, RepositoryName, MethodName, Method>(
                ...[repositoryName, methodName, ...(params ? [params] : [])]
            ),
        });

    return useCallback(callBackFn, [queryClient]);
};
